// For todays date;
Date.prototype.today = function () {
    return (
        (this.getDate() < 10 ? '0' : '') +
        this.getDate() +
        '.' +
        (this.getMonth() + 1 < 10 ? '0' : '') +
        (this.getMonth() + 1) +
        '.' +
        this.getFullYear()
    );
};
// For the time now
Date.prototype.timeNow = function () {
    return (
        (this.getHours() < 10 ? '0' : '') +
        this.getHours() +
        ':' +
        (this.getMinutes() < 10 ? '0' : '') +
        this.getMinutes() +
        ':' +
        (this.getSeconds() < 10 ? '0' : '') +
        this.getSeconds()
    );
};

window.refreshList = (data, $list, type) => {
    var newDate = new Date();
    var LastSync = 'Letzte Aktualisierung: ' + newDate.today() + ' ' + newDate.timeNow();
    fillData($list, data, type, LastSync);
    tools.toast(LastSync, 'Aktualisierung [' + type + ']');
};

window.fillData = ($list, data, type, LastSync) => {
    for (var i = 0; i < data.length; i++) {
        var $cols = $list.find('.' + type + '-' + data[i].jsID + ' >div');
        for (var n = 0; n < $cols.length; n++) {
            switch ($($cols[n]).attr('data-type')) {
                case 'Name':
                    $($cols[n]).attr('title', LastSync);
                    break;
                case 'Status':
                    var $status = $($cols[n]).find('i');
                    $status.removeClass('active');
                    $($status[data[i].status]).addClass('active');
                    break;
                case 'Gewaesser':
                    break;
                case 'Stadt':
                    break;
                case 'Wasserstand':
                    $($cols[n])
                        .find('span')
                        .html(data[i].Wasserstand + ' ' + data[i].WasserstandUnit);
                    $($cols[n]).find('small').html(data[i].WasserstandDate);
                    break;
                case 'Abfluss':
                    $($cols[n])
                        .find('span')
                        .html(data[i].Abfluss + ' ' + data[i].AbflussUnit);
                    $($cols[n]).find('small').html(data[i].AbflussDate);
                    break;
                case 'Fuellstand':
                    $($cols[n])
                        .find('span')
                        .html(data[i].Speicherfuellstand + ' ' + data[i].SpeicherfuellstandUnit);
                    $($cols[n]).find('small').html(data[i].SpeicherfuellstandDate);
                    break;
                case 'Gesamtzufluss':
                    $($cols[n])
                        .find('span')
                        .html(data[i].Gesamtzufluss + ' ' + data[i].GesamtzuflussUnit);
                    $($cols[n]).find('small').html(data[i].GesamtzuflussDate);
                    break;
                case 'Speicherinhalt':
                    $($cols[n])
                        .find('span')
                        .html(data[i].Speicherinhalt + ' ' + data[i].SpeicherinhaltUnit);
                    $($cols[n]).find('small').html(data[i].SpeicherinhaltDate);
                    break;
            }
        }
    }
};

window.startRefreshDynText = () => {
    $('.dynText').each(function (i, el) {
        var data = JSON.parse($(el).attr('data-json'));
        data.action = 'value';
        refreshPost({
            url: '/Handler/HvD/TextMarker',
            data: data,
            callback: refreshDynText,
            list: $(el),
            type: 'pegel',
            timerFunc: null
        });
    });
    setTimeout(refreshTime, startRefreshDynText);
};
window.refreshDynText = (data, $item, type) => {
    // <span title="Bever-Talsperre [Speicherf�llstand] vom 10.11.16 06:30:00" data-json="{&quot;extra&quot;:&quot;T&quot;,&quot;type&quot;:10,&quot;pid&quot;:120}" class="dynText" data-extra="T">292.07 m�NN</span>
    // title = stationName [parameterId] vom eventDate
    // data.eventDate formatieren "2016-11-10 06:30:00"
    //
    var dd = new Date(data.eventDate);
    $item.attr(
        'title',
        data.stationName +
            ' [' +
            data.parameterId +
            '] vom ' +
            dd.toLocaleDateString() +
            ' ' +
            dd.toLocaleTimeString()
    );
    $item.html(parseFloat(data.eventValue).toFixed(2) + ' ' + data.units);
};
window.startRefreshPegelList = () => {
    refreshPost({
        url: '/Handler/Refresh/Pegel',
        data: { action: 'all' },
        callback: refreshList,
        list: $('.list.pegel'),
        type: 'pegel',
        timerFunc: startRefreshPegelList
    });
};

window.startRefreshTalList = () => {
    refreshPost({
        url: '/Handler/Refresh/Talsperre',
        data: { action: 'all' },
        callback: refreshList,
        list: $('.list.talsperre'),
        type: 'tal',
        timerFunc: startRefreshTalList
    });
};

window.startRefreshWetterList = () => {
    refreshPost({
        url: '/Handler/Refresh/Wetter',
        data: { action: 'all' },
        callback: refreshList,
        list: $('.list.wetter'),
        type: 'tal',
        timerFunc: startRefreshWetterList
    });
};

window.refreshPost = (options) => {
    $.ajax({
        type: 'POST',
        url: options.url,
        data: { data: options.data },
        dataType: 'json'
    }).done(function (data) {
        options.callback(data, options.list, options.type);
        if (options.timerFunc) {
            setTimeout(options.timerFunc, refreshTime);
        }
    });
};

window.setTimeout(init, 200);
function init() {
    if (!$('body').hasClass('snapshot')) {
        /**
         * Pegel-Liste refresh
         */
        if ($('.list.pegel').length > 0) {
            setTimeout(startRefreshPegelList, refreshTime);
        }

        /**
         * Talsperren-Liste refresh
         */
        if ($('.list.talsperre').length > 0) {
            setTimeout(startRefreshTalList, refreshTime);
        }

        /**
         * Wetterstation-Liste refresh
         */
        if ($('.list.wetter').length > 0) {
            setTimeout(startRefreshWetterList, refreshTime);
        }
        /**
         * Dynamische Textelemente: Pegel...
         */
        if ($('.dynText').length > 0) {
            setTimeout(startRefreshDynText, refreshTime);
        }
    }
}
